module.exports = __webpack_public_path__ + "img/service.ab3d093d.png";